import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';
import { getProductByIdQuery } from '../queries/productById';
import { shopifyFetch } from '../utils';

/**
 * Fetch a single product from Shopify using the Storefront API
 */
export const loadShopifyProductById = async (
  storeCode: StoreCode,
  productId: string,
  identifiers?: { namespace: string; key: string }[]
): Promise<any> => {
  // Ensure the product ID is in the correct GID format
  const formattedProductId = productId.startsWith('gid://shopify/Product/')
    ? productId
    : `gid://shopify/Product/${productId}`;

  const res = await shopifyFetch<any>({
    query: getProductByIdQuery,
    shopifyDomain: SHOPIFY_STORE_DOMAIN[storeCode],
    accessToken: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    variables: {
      id: formattedProductId,
      identifiers: identifiers || [{ key: 'flavor_group', namespace: 'custom' }]
    }
  });

  return res.body.data.product;
};
